import { endpointDeclaration } from '@moojo/endpoints'
import { z } from 'zod'

import { LiveAd } from './live-ad'

export const ListLiveAdsRequest = z.object({
  publisherDomain: z.string(),
})
export type ListLiveAdsRequest = z.infer<typeof ListLiveAdsRequest>

export const ListLiveAdsResponse = z.object({
  liveAds: LiveAd.array(),
  fingerprints: z.object({
    liveAds: z.string(),
    allDomainAds: z.string(),
  }),
})
export type ListLiveAdsResponse = z.infer<typeof ListLiveAdsResponse>

export const listLiveAdsDeclaration = endpointDeclaration(ListLiveAdsRequest, ListLiveAdsResponse)
